import { useId } from "react";
import { useTranslation } from "react-i18next";
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import CheckBox from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlank from "@mui/icons-material/CheckBoxOutlineBlank";
import { v } from "../../utils/helpers";

/**
 * Zielliste mit Haken für Antrag und Release (nur Mehrzielmodus). Die Zeile ist der Schalter (role checkbox),
 * das letzte gewählte Ziel bleibt gewählt. `value` enthält targetIds, in der Reihenfolge der Ziele gespeichert.
 */
export default function TargetPicker({ targets, value, onChange, reason = null, disabled = false }) {
  const { t } = useTranslation("freigabe");
  const titleId = useId();
  const toggle = targetId => {
    const on = value.includes(targetId);
    if (on && value.length <= 1) return;
    onChange(targets.map(target => target.targetId).filter(id => id === targetId ? !on : value.includes(id)));
  };
  return <Stack component="section" spacing={0.5} aria-labelledby={titleId}>
    <Typography id={titleId} component="h3" variant="subtitle2" sx={{ color: v("text-1"), m: 0 }}>{t("stageBranches.targets.title")}</Typography>
    <Typography variant="body2" sx={{ color: v("text-2") }}>{t("stageBranches.targets.hint")}{reason ? ` ${t(`stageBranches.targets.reason.${reason}`)}` : ""}</Typography>
    <List dense disablePadding aria-labelledby={titleId}>
      {targets.map(target => {
        const on = value.includes(target.targetId), last = on && value.length <= 1;
        return <ListItem key={target.targetId} disablePadding><ListItemButton role="checkbox" aria-checked={on} aria-disabled={last || disabled || undefined}
          disabled={disabled} disableRipple onClick={() => toggle(target.targetId)} sx={{ borderRadius: "var(--r-md, 6px)", px: 1, py: 0.25, minHeight: 40 }}>
          <ListItemIcon sx={{ minWidth: 32, color: on ? "var(--iio-signal, var(--accent))" : v("text-3") }}>
            {on ? <CheckBox fontSize="small" aria-hidden/> : <CheckBoxOutlineBlank fontSize="small" aria-hidden/>}
          </ListItemIcon>
          <ListItemText primary={target.instanceName}
            secondary={[target.region, target.isDefault ? t("stageBranches.targets.default") : null, last ? t("stageBranches.targets.last") : null].filter(Boolean).join(" · ") || undefined}
            primaryTypographyProps={{ sx: { color: v("text-1"), fontWeight: 600, overflowWrap: "anywhere" } }}
            secondaryTypographyProps={{ sx: { color: v("text-2") } }}/>
        </ListItemButton></ListItem>;
      })}
    </List>
  </Stack>;
}
